import { Controller } from "react-hook-form";
import type { CapabilityName, ControllerFieldProps, FormNameForCapability } from "../types";

export default function ControllerField<TName extends CapabilityName>({
  name,
  formName,
  capabilities,
  control,
  rules,
  render
}: ControllerFieldProps<TName>) {
  if (!capabilities[name]) return null;

  return (
    <Controller
      name={(formName ?? name) as FormNameForCapability<TName>}
      control={control}
      rules={rules}
      render={render}
    />
  );
}
